import Home from './pages/Home';
import Trends from './pages/Trends/Trends';
import About from './pages/About';
import Blog from './pages/Blog';
import {MemberApp, PredictorApp} from './ServiceApps'; // Ensure this path is correct
import Map from './pages/PPMap/Map';
import SqmMap from './pages/SqmMap/SqmMap';
import PeoplesIndexMap from './pages/PeoplesIndex/PeoplesIndexMap';
import BlogPost from './pages/BlogPost';
import OpenAPIInfo from './pages/OpenAPIInfo';
import { WithAuthenticator } from './components/RequireSubscription';

import { Navigate } from 'react-router-dom';

import Privacy from './pages/Privacy';
import TermsAndConditions from './pages/TermsAndConditions';
// Define routes
const routes = [
  { path: "/", element: <Home /> },
  { path: "/home", element: <Navigate to="/" replace /> },  // Redirect /home to /
  { path: "/trends", element: <WithAuthenticator><Trends /></WithAuthenticator> },
  { path: "/map", element: <WithAuthenticator><Map /></WithAuthenticator> },
  { path: "/map/sqm", element: <WithAuthenticator><SqmMap /></WithAuthenticator> },
  { path: "/peoples-index", element: <WithAuthenticator><PeoplesIndexMap /></WithAuthenticator> },
  { path: "/api", element: <OpenAPIInfo /> },
  { path: "/about", element: <About /> },
  { path: "/members", element: <MemberApp /> },
  { path: "/machine-learning-property-price-predictor", element: <PredictorApp /> },
  { path: "/catalog", element: <Navigate to="/machine-learning-property-price-predictor" replace /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/terms", element: <TermsAndConditions /> },
  {path: "/blog", element: <Blog />},
  {path: "/:postId", element: <BlogPost />},
  { path: "*", element: <p>Page not found</p> }
];

export default routes;
